import React, { Component } from 'react';

export default class Page403 extends Component {
  static propTypes = {

  };

  render() {
    return (
      <div className="error-page-403">
        Component content: error/Page403
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/error/Page403.js